export const SITE = {
  name: 'Royaume des Sacrificateurs',
  shortName: 'RDS',
  domain: 'www.royaumedesacrificateurs.com',
  location: 'Brazzaville, République du Congo',
  email: 'contact@royaumedesacrificateurs.com',
  phone: '+242 06 682 8877',
  phoneHref: '+242066828877',
  social: {
    facebook: 'https://facebook.com/',
    youtube: 'https://youtube.com/',
    instagram: 'https://instagram.com/',
  },
  worshipTimes: [
    { label: 'Culte dominical', value: 'Dimanche · 09h00' },
    { label: 'Étude biblique', value: 'Mercredi · 17h30' },
    { label: 'Prière communautaire', value: 'Vendredi · 17h30' },
  ],
  heroImage:
    'https://images.unsplash.com/photo-1507692049790-de58290a4334?auto=format&fit=crop&w=2200&q=88',
  fallbackImages: {
    teaching:
      'https://images.unsplash.com/photo-1438232992991-995b7058bbb3?auto=format&fit=crop&w=1400&q=82',
    news:
      'https://images.unsplash.com/photo-1473177104440-ffee2f376098?auto=format&fit=crop&w=1400&q=82',
    about:
      'https://images.unsplash.com/photo-1491396023581-4344e51fec5c?auto=format&fit=crop&w=1800&q=84',
  },
}

export const NAV_ITEMS = [
  { label: 'Accueil', to: '/' },
  { label: 'À propos', to: '/a-propos' },
  { label: 'Enseignements', to: '/enseignements' },
  { label: 'Cantiques', to: '/cantiques' },
  { label: 'Bible', to: '/bible' },
  { label: 'Actualités', to: '/actualites' },
  { label: 'Contact', to: '/contact' },
]
